module.exports = __webpack_public_path__ + "img/index-section6-friend5_a.8c75efa3.svg";